import { Component, input } from '@angular/core';
import { ValidationError } from '@angular/forms/signals';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'juno-libs-ui-error',
  imports: [TranslocoDirective],
  templateUrl: './juno-error.html',
  styleUrl: './juno-error.css',
})
export class JunoError {
  errors = input.required<readonly ValidationError.WithOptionalFieldTree[]>();
  appliedClasses = input<string>();
}
